import { render, staticRenderFns } from "./ENotaInputResultado.vue?vue&type=template&id=2110ee2c"
import script from "./ENotaInputResultado.vue?vue&type=script&lang=js"
export * from "./ENotaInputResultado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports